import React from "react"

const Error404 = () => {
  return (
    <div className="ui-g ui-g-12 ">
      <div className="ui-g-12 text-center">
        <h1>HTTP Error 404: Page not found</h1>
      </div>
      <div className="ui-g-12 text-center">
        <h3>Sorry, Page not found!</h3>
      </div>
    </div>
  )
}

export default Error404


// WEBPACK FOOTER //
// ./src/components/common/Error404.js